module.exports = __webpack_public_path__ + "img/jianjietopmin.e47e7968.jpg";